import React from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import MenuGrid from "../../../PublicOrdering/pages/MenuGrid";
import DesktopCartSidebar from "../../../PublicOrdering/pages/DesktopCartSidebar";
import playBeep from "../../../PublicOrdering/pages/PlayBeep";

/**
 * NormalLayout Component
 * Handles the normal (non-touch-based) UI layout with menu and cart sidebar
 * Also includes My Orders floating button
 */
const NormalLayout = ({
  loading,
  filteredItems,
  cart,
  onAddItem,
  onRemoveItem,
  onCardClick,
  onMyOrdersClick,
  orgData,
  multipleTenant,
}) => {
  return (
    <div className="">
      <Row style={{ maxHeight: "100dvh" }} className="">
        {/* Menu Grid */}
        <Col xs={12} lg={8}>
          {loading ? (
            <Row>
              {[...Array(16)].map((_, idx) => (
                <Col xs={6} sm={6} md={3} lg={3} key={idx}>
                  <Card
                    className="border-0"
                    style={{ borderRadius: 10, padding: 6 }}
                  >
                    <Skeleton height={90} borderRadius={6} />
                    <CardBody style={{ padding: 8 }}>
                      <Skeleton
                        height={14}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />
                      <Skeleton height={14} width="60%" />
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <MenuGrid
              filteredItems={filteredItems}
              cart={cart.map((c) => ({
                id: c.productId || c.id,
                quantity: c.quantity || c.qty,
              }))}
              onAdd={onAddItem}
              onRemove={onRemoveItem}
              onCardClick={onCardClick}
              multipleTenant={multipleTenant}
            />
          )}
        </Col>

        {/* Desktop Cart Sidebar */}
        <Col lg={4} className="d-none d-lg-block d-md-block">
          <div
            style={{
              position: "sticky",
              // height: "calc(100vh - 40vh)",
              height: multipleTenant
                ? "calc(100vh - 46.5vh)"
                : "calc(100vh - 40vh)",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              border: "none",
              overflow: "hidden",
              padding: "0",
            }}
          >
            {loading ? (
              <Card
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardBody
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <Skeleton height={20} width="60%" borderRadius={4} />
                  <Skeleton height={40} borderRadius={6} />
                  <Skeleton height={60} borderRadius={8} />
                  <Skeleton height={60} borderRadius={8} />
                  <Skeleton height={60} borderRadius={8} />
                  <div style={{ flex: 1 }} />
                  <Skeleton height={40} borderRadius={6} />
                </CardBody>
              </Card>
            ) : (
              <DesktopCartSidebar
                cart={cart}
                orgInfo={orgData}
                orgData={orgData}
                isTouchBased={true}
                multipleTenant={multipleTenant}
              />
            )}
          </div>
        </Col>
      </Row>

      {/* Floating My Orders Button */}
      {/* <Button
        color="link"
        onClick={() => {
          playBeep();
          onMyOrdersClick();
        }}
        style={{
          position: "fixed",
          right: "20px",
          bottom: "80px",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          backgroundColor: "#ff7900",
          border: "none",
          padding: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999,
          boxShadow: "0 4px 12px rgba(255, 121, 0, 0.3)",
          transition: "all 0.3s ease",
        }}
      >
        <i
          className="bx bx-receipt"
          style={{ fontSize: "24px", color: "#fff" }}
        />
      </Button> */}
    </div>
  );
};

export default NormalLayout;
